'use strict';

module.exports = require('./lib/ReactDOM');



/** WEBPACK FOOTER **
 ** ./~/react-dom/index.js
 **/